import { energyAnalysisApiSlice } from '../apiSlice';

export const systemQoSApiSlice = energyAnalysisApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllSystemQoS: builder.query({
      query: () => `/all_system_qos`,
      providesTags: ['EnergyAnalysis'],
    }),

    getSystemQoSById: builder.query({
      query: ({ energyGroupId, accountId }) => ({
        url: `/system_qos/${accountId}/${energyGroupId}`,
      }),
      providesTags: ['EnergyAnalysis'],
    }),
  }),
});

export const {
  useGetAllSystemQoSQuery,
  useGetSystemQoSByIdQuery,
  useLazyGetSystemQoSByIdQuery,
} = systemQoSApiSlice;
